export default __webpack_public_path__ + "static/media/silver.c1560df8.svg";